<div translate="no" class="tech-container">
    <ion-fab>
      <ion-fab-button edge class="tech-container__icon" (click)="exitTechMode()">
        <ion-icon name="exit-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
</div>